import React from 'react';

function Navbar({ activeTab, onTabChange }) {
  return (
    <nav className="navbar">
      <div className="navbar-logo" onClick={() => onTabChange('search')} style={{ cursor: 'pointer' }}>
  <img src={`${process.env.PUBLIC_URL}/ANIME_SEARCH.png`} alt="Anime Search Logo" className="logo-img" />
</div>
      <ul className="navbar-links">
        <li>
          <button
            className={activeTab === 'search' ? 'active' : ''}
            onClick={() => onTabChange('search')}
          >
            Search
          </button>
        </li>
        <li>
          <button
            className={activeTab === 'top' ? 'active' : ''}
            onClick={() => onTabChange('top')}
          >
            Top Anime
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;